import { SubcontractorContractData } from 'src/lib/fliko/models/estate/subcontractor.data';

export class SubHlp {
  public static getLastContract(contracts: SubcontractorContractData[]): SubcontractorContractData | null {
    // TODO: check if last contract is active
    let last: SubcontractorContractData | null = null;
    const now = Date.now();
    for (const con of contracts) {
      if (last) {
        if (last.indef && con.indef) {
          last = con.startDate > last.startDate ? con : last;
        } else if (con.indef || (con.startDate < now && (con.startDate > last.startDate || con.endDate! > last.endDate!))) {
          last = con;
        }
      } else {
        last = con;
      }
    }
    return last;
  }
}
